import { Button } from '@mc/design-system'
import { Trans, useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { trackPurchaseNowClick } from '../SelfServe/utils/events'
import { trackConnectClick, type MawPageSource } from '../events'
import { scrollToContactForm } from '../scrollToContactForm'
import { CertificatesCard } from './CertificatesCard'
import { PricingCard, PricingCardLogo } from './PricingCard'
import styles from './PricingCard.module.scss'

interface PricingTiersProps {
  pageSource: MawPageSource
}

export const PricingTiers = ({ pageSource }: PricingTiersProps) => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='mc-mt-12' id='pricing-section'>
      <div className={`mc-mx-auto ${styles.tiers}`}>
        <div className='d-flex flex-column flex-lg-row justify-content-center mc-gap-4 mc-gap-lg-8'>
          <PricingCard
            logo={
              <PricingCardLogo
                src='https://static.masterclass.com/MC.png'
                alt='MasterClass logo'
              />
            }
            title={t('forBusiness.pricingSection.masterClass.title')}
            subtitle={t('forBusiness.pricingSection.masterClass.subtitle')}
            startingAtLabel={t(
              'forBusiness.pricingSection.masterClass.startingAt',
            )}
            price={t('forBusiness.pricingSection.masterClass.price')}
            pricePeriod={t(
              'forBusiness.pricingSection.masterClass.priceSubtext',
            )}
            features={[
              t('forBusiness.pricingSection.masterClass.feature1'),
              t('forBusiness.pricingSection.masterClass.feature2'),
              t('forBusiness.pricingSection.masterClass.feature3'),
            ]}
            cta={
              <Button
                render={<a href={paths.checkoutEnterpriseGift()} />}
                className='mc-w-100'
                onClick={() => trackPurchaseNowClick({ pageSource })}
              >
                {t('forBusiness.pricingSection.masterClass.button')}
              </Button>
            }
            disclaimer={t('forBusiness.pricingSection.masterClass.disclaimer')}
          />
          <PricingCard
            logo={
              <PricingCardLogo
                src='https://static.masterclass.com/MC+at+W.png'
                alt='MasterClass at Work logo'
              />
            }
            title={t('forBusiness.pricingSection.masterClassAtWork.title')}
            subtitle={t('forBusiness.pricingTiers.masterClassAtWork.subtitle')}
            startingAtLabel={t(
              'forBusiness.pricingSection.masterClassAtWork.startingAt',
            )}
            price={t('forBusiness.pricingSection.masterClassAtWork.price')}
            pricePeriod={t(
              'forBusiness.pricingSection.masterClassAtWork.priceSubtext',
            )}
            features={[
              t('forBusiness.pricingSection.masterClassAtWork.feature1'),
              t('forBusiness.pricingSection.masterClassAtWork.feature2'),
              t('forBusiness.pricingSection.masterClassAtWork.feature3'),
              t('forBusiness.pricingSection.masterClassAtWork.feature4'),
              t('forBusiness.pricingSection.masterClassAtWork.feature5'),
            ]}
            cta={
              <Button
                render={<a href={paths.enterpriseCart} />}
                className='mc-w-100'
                onClick={() => trackPurchaseNowClick({ pageSource })}
              >
                {t('forBusiness.pricingSection.masterClassAtWork.button')}
              </Button>
            }
            disclaimer={
              <Trans
                i18nKey='forBusiness.pricingTiers.masterClassAtWork.disclaimer'
                ns='@mc/next'
              >
                <a
                  href='#contact-form'
                  className='mc-text--link'
                  onClick={(e) => {
                    e.preventDefault()
                    trackConnectClick({
                      location: 'homepage-pricing-large-team',
                      pageSource,
                    })
                    scrollToContactForm()
                  }}
                ></a>
              </Trans>
            }
          />
        </div>
        <CertificatesCard
          onCtaClick={() =>
            trackConnectClick({
              location: 'homepage-pricing-certificates',
              pageSource,
            })
          }
        />
      </div>
    </div>
  )
}
